import PaymentInfoSection from './PaymentInfoSection';
import { PaymentInfoSectionProps, PaymentInfoSectionValueProps } from './types';

export type { PaymentInfoSectionProps, PaymentInfoSectionValueProps };
export default PaymentInfoSection;
